import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { injectIntl } from "react-intl";
var classNames = require("classnames");
var JDate = require("jalali-date");
import API from "../../api/index";
import moment from "jalali-moment";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import { Row, Card, CardBody, CardTitle, Form, FormGroup, Button, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table, Collapse, CustomInput } from "reactstrap";

import NumberFormat from "react-number-format";

import { Colxx } from "Components/CustomBootstrap";
import StateButton from "Components/StateButton";

const jdate = new JDate();
const persianMonths = {
	1: "فروردین",
	2: "اردیبهشت",
	3: "خرداد",
	4: "تیر",
	5: "مرداد",
	6: "شهریور",
	7: "مهر",
	8: "آبان",
	9: "آذر",
	10: "دی",
	11: "بهمن",
	12: "اسفند",
};
class ViewCustomer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			smsLatestLoading: false,
			Customer: {},
			OrdersInsight:{},
			Addresses: [],
			Orders: [],
			OpenOrders: [],
			TimeLine: [],
			curTime: new Date().toISOString().substr(11, 8),
			isLoading: true,
			TotalOrders: 0,
			couponUsesTableIsLoading: true,
			couponUsesTableCurrentPage: 1,
			couponUses: [],
			couponUsesPaging: {},
			couponTargetedTableIsLoading: true,
			couponTargetedTableCurrentPage: 1,
			couponTargeted: [],
			couponTargetedPaging: {},
		};

		this.updateSize = this.updateSize.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.loadData();

		this.loadSMSLatest = this.loadSMSLatest.bind(this);
		this.toggleSMS = this.toggleSMS.bind(this);
		this.loadCouponUsageData = this.loadCouponUsageData.bind(this);
		this.loadCouponTargetedData = this.loadCouponTargetedData.bind(this);
	}
	loadCouponUsageData() {
		API.post("crm/coupon/customer-uses-list", { customerId: this.state.Customer.CustomerId, currentPage: this.state.couponUsesTableCurrentPage })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					couponUses: data.couponUses,
					couponUsesPaging: data.paging,
					couponUsesTableIsLoading: false,
				});
			})
			.catch((error) => {});
	}
	loadCouponTargetedData() {
		API.post("crm/coupon/customer-targeted-list", { customerId: this.state.Customer.CustomerId, currentPage: this.state.couponTargetedTableCurrentPage })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState({
					couponTargeted: data.couponTargeted,
					couponTargetedPaging: data.paging,
					couponTargetedTableIsLoading: false,
				});
			})
			.catch((error) => {});
	}
	toggleSMS() {
		return new Promise((success, fail, $this) => {
			this.setState({ toggleSMSClicked: true });

			API.sms
				.toggleBanned({
					NodeID: this.state.Customer.CustomerId,
				})
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در تغییر وضعیت دریافت پیامک ");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ویرایش وضعیت دریافت پیامک ", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								toggleSMSClicked: false,
							});
						}
					} else {
						success("تغییر وضعیت ثبت شد");
						setTimeout(() => {
							this.setState(
								{
									toggleSMSClicked: false,
								},
								() => {
									this.loadData();
								}
							);
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در تغییر وضعیت دریافت پیامک ");
				});
		});
	}
	loadData(key) {
		API.customer
			.view({ CustomerMobile: this.props.match.params.CustomerId })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState(
					{
						Customer: data.Customer,
						isLoading: false,
						Addresses: data.Addresses,
						Orders: data.Orders,
						OpenOrders: data.OpenOrders,
						TotalOrders: data.TotalOrders,
						OrdersInsight:data.OrdersInsight
					},
					() => {
						this.updateSize();
						this.loadCouponUsageData();
						this.loadCouponTargetedData();
						this.loadSMSLatest();
					}
				);
			})
			.catch((error) => {});
	}
	loadSMSLatest(key) {
		this.setState({ smsLatestLoading: true });
		API.customer
			.smsLatest({ CustomerID: this.state.Customer.CustomerId })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				this.setState(
					{
						TimeLine: data.TimeLine,
						smsLatestLoading: false,
					},
					() => {
						this.updateSize();
					}
				);
			})
			.catch((error) => {});
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateSize);
		this.updateSize();
	}
	updateSize() {
		if (!this.state.isLoading && document.querySelector(".auto-win-height") !== null) {
			window.autoWinWidth = document.querySelector(".auto-win-height").offsetWidth;
			document.querySelector(".auto-win-height").style.overflow = "hidden";
			document.querySelector(".auto-win-height").style.width = document.querySelector("#side-card").offsetWidth + "px";
			document.querySelector(".auto-win-height").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 80 + "px";
			document.querySelector(".auto-win-height").style.position = "fixed";
			document.querySelector(".auto-win-height").style.top = document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight + 40 + "px";
			document.querySelector(".auto-win-height-scroll").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 200 + "px";
			document.querySelector(".auto-win-height-scroll").style.overflow = "scroll";
		}
	}

	nl2br = (str) => {
		var breakTag = "<br/>";
		var replaceStr = "$1" + breakTag;
		// var replaceStr = '$1'+ breakTag +'$2';
		return (str + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
	};

	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className="mb-4">
					<Colxx xxs="12">
						<Form>
							<FormGroup row>
								<Colxx sm={6}>
									<Card className="timeline-card auto-win-height" style={{ backgroundColor: "transparent" }}>
										<CardBody style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
											<CardTitle>
												<div className={"iconsminds-mail-send headingicon"} />
												پیامک‌های جدید
												{localStorage.getItem("user_can").split(",").indexOf("manage-sms") == -1 ? (
													<span className={"cardtitleicons biginfo sms-toggle-customer"} style={{ border: "unset", background: "white", color: this.state.Customer.smsBanned ? "darkorange" : "#56cfc6" }}>
														<i
															style={{ fontSize: "16px", marginLeft: "10px" }}
															className={classNames({
																"iconsminds-mail-block": this.state.Customer.smsBanned,
																"iconsminds-mail-inbox": !this.state.Customer.smsBanned,
															})}
														></i>
														{classNames({
															"پیامک مسدود": this.state.Customer.smsBanned,
															"پیامک فعال": !this.state.Customer.smsBanned,
														})}
													</span>
												) : (
													<StateButton
														disabled={false}
														id="toggleSMS"
														color="light"
														className={classNames({
															default: true,
															"mb-2": true,
															"outline-dark-btn": true,
															"sms-toggle-button": true,
															"sms-toggle-button-active": !this.state.Customer.smsBanned,
															"sms-toggle-button-blocked": this.state.Customer.smsBanned,
															"sms-toggle-customer": true,
														})}
														onClick={() => this.toggleSMS()}
													>
														<i
															style={{ fontSize: "16px", marginLeft: "10px" }}
															className={classNames({
																"iconsminds-mail-block": this.state.Customer.smsBanned,
																"iconsminds-mail-inbox": !this.state.Customer.smsBanned,
															})}
														></i>
														{classNames({
															"پیامک مسدود": this.state.Customer.smsBanned,
															"پیامک فعال": !this.state.Customer.smsBanned,
														})}
													</StateButton>
												)}
												<Button
													onClick={() => {
														window.open("https://smp.akschap.com/report-mobile/" + this.state.Customer.Mobile);
													}}
													disabled={false}
													id="toggleSMS"
													className="default mb-2"
													style={{ position: "absolute", left: "160px", top: "20px", color: "#60707c" }}
													color="secondary"
												>
													همه پیامک ها
												</Button>
											</CardTitle>
											<div className={"auto-win-height-scroll"}>
												<br />
												<Timeline lineColor={"#ddd"}>
													{this.state.TimeLine.map((item, index) => {
														return (
															<TimelineItem
																key={index}
																dateText={item.date}
																dateComponent={
																	<span className="timeline-item-date">
																		<time className="timeline-item-dateinner" title="1400-02-03 14:45:13">
																			{item.dow}
																			<br />
																			{moment(item.date.split(" ")[0]).locale("fa").format("DD MMMM YYYY")}
																			{}
																			<br />
																			{item.date.split(" ")[1]}
																			<br />
																			<span className={"timelineoperator"}>
																				{/* <i className={"iconsminds-consulting"}></i> */}
																				{item.status}
																			</span>
																		</time>
																	</span>
																}
																className={classNames({
																	"timeline-item-sms": item.type == "sms",
																	"timeline-item-important": item.important,
																	"timeline-item-success": item.type == "created" || item.type == "processed_success",
																	"timeline-item-danger": item.type == "processed_canceled",
																	"timeline-item-payment": item.type == "payment_online" || item.type == "payment_card" || item.type == "payment_poscash",
																	"timeline-item-note": item.type == "note",
																	"timeline-item-customer": item.type == "customerfeedback" || item.type == "customer_rating",
																})}
															>
																<h3 className={"timelinetitle "}>
																	<i
																		className={classNames({
																			"iconsminds-add-file": item.type == "created" ? true : false,
																			"iconsminds-mail-favorite": item.type == "sms" ? true : false,
																			"simple-icon-eye": item.type == "linkvisit" ? true : false,
																			"simple-icon-globe": item.type == "payment_online" ? true : false,
																			"iconsminds-coins": item.type == "payment_poscash" ? true : false,
																			"iconsminds-credit-card": item.type == "payment_card" ? true : false,
																			"simple-icon-call-end": item.type == "missedCall" ? true : false,
																			"simple-icon-bubbles": item.type == "whatsappMessage" ? true : false,
																			"simple-icon-call-out": item.type == "call" ? true : false,
																			"simple-icon-check": item.type == "processed_success" ? true : false,
																			"simple-icon-close": item.type == "processed_canceled" ? true : false,
																			"simple-icon-notebook": item.type == "note" ? true : false,
																			"simple-icon-star": item.type == "customer_rating" ? true : false,
																			"iconsminds-business-man-woman": item.type == "customerfeedback" ? true : false,
																		})}
																	></i>
																	{item.title}
																</h3>
																<span className={"timelinecomment"} style={{ display: item.comment.length > 0 ? "block" : "none" }}>
																	{item.comment.split("\n").map((content, index) => {
																		if (content.trim() == "") {
																			return;
																		}
																		return <p key={index}>{content}</p>;
																	})}
																</span>
															</TimelineItem>
														);
													})}

													{/* <TimelineItem
														key={100012323}
														dateText={"2323232323"}
														dateComponent={
															<span className="timeline-item-date">
																<time className="timeline-item-dateinner" title="1400-02-03 14:45:13">
																	{jdate.format("dddd")}
																	<br />
																	{jdate.format("YYYY-MM-DD")}
																	<br />
																	{this.state.curTime}
																	<br />
																	<span className={"timelineoperator"}>
																		<i className={"iconsminds-consulting"}></i>
																		رامین
																	</span>
																</time>
															</span>
														}
														className={"new-entry-item"}
													>
														<h3 className={"timelinetitle "}>
															<i className={""}></i>
															ثبت رویداد جدید
														</h3>
														<select>
															<option value="-1">تماس بی پاسخ</option>
															<option value="-1">پیام واتس اپ</option>
															<option value="-1">تماس تلفنی</option>
															<option value="-1">یادداشت اپراتور</option>
															<option value="-1">فیدبک مشتری</option>
														</select>

														<CustomInput type="checkbox" id="exCustomRadio" name="customRadio" label="رویداد مهم" />

														<textarea></textarea>
														<Button color="primary" className="default mb-2" style={{ float: "left" }}>
															ثبت
														</Button>
													</TimelineItem> */}
												</Timeline>
											</div>
										</CardBody>
									</Card>
								</Colxx>

								<Colxx sm={6}>
									<Card id={"side-card"}>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>
												<div
													className={classNames({
														"iconsminds-business-man": this.state.Customer.Gender != null && this.state.Customer.Gender.toLowerCase() == "male" ? true : false,
														"iconsminds-business-woman": this.state.Customer.Gender != null && this.state.Customer.Gender.toLowerCase() == "female" ? true : false,
														headingicon: true,
													})}
												/>
												{this.state.Customer.Name} {this.state.Customer.SurName}
												<div style={{ float: "left", fontSize: "18px" }}>
													<a href={"/app/customers/view-customer/" + this.state.Customer.Mobile}>
														{this.state.Customer.Mobile}
														<div className={" simple-icon-screen-smartphone icongotoorder"} />
													</a>{" "}
												</div>
											</CardTitle>

											<div>
												{this.state.Customer.BirthDay.Day != null && this.state.Customer.BirthDay.Month != null && this.state.Customer.BirthDay.Year != null ? (
													<span className={"cardtitleicons"}>
														<i className={"iconsminds-cake"}></i>
														{this.state.Customer.BirthDay.Day}
														{" / "}
														{persianMonths[this.state.Customer.BirthDay.Month]}
														{" / "}
														{this.state.Customer.BirthDay.Year}
													</span>
												) : null}
												{this.state.Customer.Gender != null && this.state.Customer.Age != null ? (
													<span className={"cardtitleicons"}>
														<i className={"simple-icon-info"}></i>
														{this.state.Customer.Gender == "MALE" ? "آقای" : "خانم"} {this.state.Customer.Age}
														{" ساله"}
													</span>
												) : null}
												{this.state.Customer.FamiliarityMethod != null ? (
													<span className={"cardtitleicons"}>
														<i className={"simple-icon-info"}></i>
														{"روش آشنایی:"} <strong>{this.state.Customer.FamiliarityMethod}</strong>
													</span>
												) : null}
												{/* {this.state.order.Address != false ? (
													<StateButton
														disabled={this.state.reprintAddressClicked}
														color="light"
														id="reprintaddressbtn"
														className="default mb-2 outline-dark-btn float-left"
														style={{ display: "inline-block", float: "left" }}
														onClick={this.handleReprintAddress}
													>
														<i className="simple-icon-printer"></i>&nbsp; پرینت مجدد آدرس
													</StateButton>
												) : (
													<div />
												)} */}
											</div>
										</CardBody>
										<br />
									</Card>
									{this.state.OpenOrders.length > 0 ? <br /> : null}
									{this.state.OpenOrders.length > 0 ? (
										<Card id={"side-card"}>
											<CardBody style={{ paddingBottom: "0px" }}>
												<CardTitle>سفارشات جاری</CardTitle>

												<table className="table table-hover order-table">
													<thead>
														<tr>
															<th>شماره سفارش</th>
															<th>زمان ثبت</th>
															<th>مبلغ سفارش </th>
															<th>وضعیت</th>
														</tr>
													</thead>
													<tbody>
														{this.state.OpenOrders.map((row, index) => (
															<TableOpenOrdersRows key={index} data={row} />
														))}
													</tbody>
												</table>
											</CardBody>
											<br />
										</Card>
									) : null}
									<br />
									<Card id={"side-card"}>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>آمار سفارشات</CardTitle>
											<table className="table table-hover order-table">
												<thead>
													<tr>
														<th> </th>
														<th>سفارش موفق</th>
														<th>پرداخت موفق</th>
														<th>میانگین سفارش</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>
															<strong>
															کل
															</strong>
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.total.count} className="text-muted" displayType={"text"} suffix={" فاکتور"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.total.sum} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.total.avg} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
													</tr>
													<tr style={{background:"#f2fff6"}}>
														<td>
															<strong>
															امسال
															</strong>
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.year.count} className="text-muted" displayType={"text"} suffix={" فاکتور"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.year.sum} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
														<td>
															<NumberFormat style={{ textAlign: "center" }} value={this.state.OrdersInsight.Success.year.avg} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
														</td>
													</tr>
												</tbody>
											</table>
										</CardBody>
									</Card>
									<br />
									<Card id={"side-card"}>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>
												آرشیو سفارشات
												<div style={{ float: "left", fontSize: "18px" }}>
													<a target="_blank" href={"/app/orders/archive/" + this.state.Customer.Mobile}>
														{"مشاهده همه ("}
														{this.state.TotalOrders}
														{")"}
														<div className={" simple-icon-arrow-left-circle icongotoorder"} />
													</a>{" "}
												</div>
											</CardTitle>

											<table className="table table-hover order-table">
												<thead>
													<tr>
														<th>شماره سفارش</th>
														<th>زمان ثبت</th>
														<th>زمان تحویل </th>
														<th>مبلغ سفارش </th>
														<th>وضعیت</th>
													</tr>
												</thead>
												<tbody>
													{this.state.Orders.map((row, index) => (
														<TableBodyRows key={index} data={row} />
													))}
												</tbody>
											</table>
										</CardBody>
										<br />
									</Card>
									<br />
									<Card id={"side-card"}>
										<CardBody style={{ paddingBottom: "0px" }}>
											<CardTitle>استفاده از کوپن</CardTitle>

											{!this.state.couponUsesTableIsLoading ? (
												<div className="table-responsive">
													<table className="table table-hover order-table">
														<thead>
															<tr>
																<th>#</th>
																<th>سفارش</th>
																<th>کوپن</th>
																<th>بیشتر</th>
															</tr>
														</thead>
														{this.state.couponUses.map((row) => (
															<CouponUseTableRow key={row.couponUseId} data={row} />
														))}
														<tfoot>
															<tr>
																<td colSpan={12}>
																	<div className="table-pagination">
																		{this.state.couponUsesPaging.pages.map((page, index) => (
																			<Button
																				key={index}
																				className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																				onClick={(e) => {
																					if (page.ellipse) {
																						return;
																					}

																					this.setState({ couponUsesTableCurrentPage: page.page, couponUsesTableIsLoading: true }, () => {
																						this.loadCouponUsageData();
																					});
																				}}
																			>
																				{page.page}
																			</Button>
																		))}

																		<div className={"text-muted"} style={{ display: "block", clear: "both", marginTop: "16px", fontSize: "14px" }}>
																			نمایش {this.state.couponUsesPaging.from + 1} - {Math.min(this.state.couponUsesPaging.to, this.state.couponUsesPaging.total)} از {this.state.couponUsesPaging.total} استفاده از کوپن
																		</div>
																	</div>
																</td>
															</tr>
														</tfoot>
													</table>
												</div>
											) : (
												<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
											)}
										</CardBody>
										<br />
									</Card>
									<br />
									{this.state.couponTargeted.length > 0 ? (
										<>
											<Card id={"side-card"}>
												<CardBody style={{ paddingBottom: "0px" }}>
													<CardTitle>کوپن با هدف این مشتری</CardTitle>

													{!this.state.couponTargetedTableIsLoading ? (
														<div className="table-responsive">
															<table className="table table-hover order-table">
																<thead>
																	<tr>
																		<th>ایجاد / انقضاء</th>
																		<th>موضوع</th>
																		<th>کوپن</th>
																	</tr>
																</thead>
																{this.state.couponTargeted.map((row) => (
																	<CouponTargetedTableRow key={row.couponID} data={row} />
																))}
																<tfoot>
																	<tr>
																		<td colSpan={12}>
																			<div className="table-pagination">
																				{this.state.couponTargetedPaging.pages.map((page, index) => (
																					<Button
																						key={index}
																						className={classNames({ "mb-2": true, "pagination-item": true, "pagination-number": true, "pagination-current": page.current })}
																						onClick={(e) => {
																							if (page.ellipse) {
																								return;
																							}

																							this.setState({ couponTargetedTableCurrentPage: page.page, couponTargetedTableIsLoading: true }, () => {
																								this.loadCouponTargetedData();
																							});
																						}}
																					>
																						{page.page}
																					</Button>
																				))}

																				<div className={"text-muted"} style={{ display: "block", clear: "both", marginTop: "16px", fontSize: "14px" }}>
																					نمایش {this.state.couponTargetedPaging.from + 1} - {Math.min(this.state.couponTargetedPaging.to, this.state.couponTargetedPaging.total)} از{" "}
																					{this.state.couponTargetedPaging.total} از کوپن
																				</div>
																			</div>
																		</td>
																	</tr>
																</tfoot>
															</table>
														</div>
													) : (
														<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
													)}
												</CardBody>
												<br />
											</Card>
											<br />
										</>
									) : null}

									<Card>
										<CardBody>
											<CardTitle>
												<div className={"headingicon simple-icon-location-pin"} />
												آدرس ها
											</CardTitle>
											{this.state.Addresses.map((row, index) => (
												<table key={index} style={{ width: "100%" }} className={"address-item"}>
													<tbody>
														<tr>
															<td style={{ width: "100px", fontWeight: "bold" }}>تحویل گیرنده:</td>
															<td style={{ width: "calc(50% - 100px)" }}>
																<i
																	className={classNames({
																		"iconsminds-business-man": row.Gender == "male" ? true : false,
																		"iconsminds-business-woman": row.Gender == "female" ? true : false,
																	})}
																></i>
																{row.Name} {row.SurName}
															</td>
															<td style={{ width: "25%" }}>
																<i className={"simple-icon-screen-smartphone"}></i>&nbsp;
																{row.Mobile}
															</td>
															<td style={{ width: "25%" }}>
																<i className={"iconsminds-old-telephone"}></i>&nbsp;
																{row.Tel}
															</td>
														</tr>
														<tr>
															<td>
																<strong>آدرس:&nbsp;</strong>
															</td>
															<td colSpan={3}>
																{row.State} - &nbsp;
																{row.City} - &nbsp;
																{row.Address} &nbsp;
															</td>
														</tr>
														<tr>
															<td>
																<strong>کد پستی:&nbsp;</strong>
															</td>
															<td colSpan={3}>{row.PostCode}</td>
														</tr>
													</tbody>
												</table>
											))}
										</CardBody>
									</Card>
								</Colxx>
							</FormGroup>
						</Form>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TableBodyRows extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const orderStatePersian = [];
		orderStatePersian["FAILED"] = "کنسل شد";
		orderStatePersian["SUCCESS"] = "تکمیل شد";
		orderStatePersian["NONE"] = "باز";

		const orderStateColor = [];
		orderStateColor["FAILED"] = "red";
		orderStateColor["SUCCESS"] = "green";
		orderStateColor["NONE"] = "darkorange";

		const {
			data: { OrderId, OpenedAt, ClosedAt, Payable, Result },
		} = this.props;
		return (
			<tr className={"order-item"}>
				<td>
					<a href={"/app/orders/view-order/" + OrderId}>
						{" "}
						{OrderId} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
					</a>
				</td>
				<td style={{ width: "120px" }}>
					{moment(OpenedAt.split("T")[0]).locale("fa").format("DD MMMM YYYY")}
					<br />
					{OpenedAt.split("T")[1]}
				</td>
				<td style={{ width: "120px" }}>
					{moment(ClosedAt.split("T")[0]).locale("fa").format("YYYY") == "1358" ? (
						<span>
							-- -- ----
							<br />
							--:--:--
						</span>
					) : (
						<span>
							{moment(ClosedAt.split("T")[0]).locale("fa").format("DD MMMM YYYY")}
							<br />
							{ClosedAt.split("T")[1]}
						</span>
					)}
				</td>
				<td style={{ textAlign: "center" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} /> تومان
				</td>
				<td style={{ color: orderStateColor[Result] }}>{orderStatePersian[Result]}</td>
			</tr>
		);
	}
}
class TableOpenOrdersRows extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const orderStatePersian = [];
		orderStatePersian["PAYMENT"] = "صف پرداخت";
		orderStatePersian["PROCESS"] = "صف پردازش";

		const orderStateColor = [];
		orderStateColor["PAYMENT"] = "blue";
		orderStateColor["PROCESS"] = "green";

		const {
			data: { OrderId, OpenedAt, ClosedAt, Payable, Result, Position },
		} = this.props;
		return (
			<tr className={"order-item"}>
				<td>
					<a href={"/app/orders/view-order/" + OrderId}>
						{" "}
						{OrderId} <div className={" simple-icon-arrow-left-circle icongotoorder"} />
					</a>
				</td>
				<td style={{ width: "120px" }}>
					{moment(OpenedAt.split("T")[0]).locale("fa").format("DD MMMM YYYY")}
					<br />
					{OpenedAt.split("T")[1]}
				</td>
				<td style={{ textAlign: "center" }}>
					<NumberFormat style={{ textAlign: "center" }} value={Payable} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} /> تومان
				</td>
				<td style={{ color: orderStateColor[Position] }}>{orderStatePersian[Position]}</td>
			</tr>
		);
	}
}

class CouponUseTableRow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
		};
		this.toggle = this.toggle.bind(this);
	}
	toggle() {
		if (this.state.clicked) {
			return;
		}
		this.setState({
			modal: !this.state.modal,
		});
	}

	render() {
		const {
			data: { couponUseId, createdAt, orderId, coupon, couponId, totalPrice, description, totalDiscount, payable, isDeleted, operatorName },
		} = this.props;
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td className={"text-muted"} style={{ verticalAlign: "middle" }}>
						{couponUseId}{" "}
						<i
							style={{ color: isDeleted == "1" ? "red" : "green" }}
							className={classNames({
								"simple-icon-close": isDeleted == "1" ? true : false,
								"simple-icon-check": isDeleted == "0" ? true : false,
							})}
						></i>
						<br />
						{moment(createdAt).locale("fa").format("YYYY/MM/DD - HH:mm")}
					</td>
					<td style={{ verticalAlign: "middle" }}>
						<a href={"/app/orders/view-order/" + orderId} target="_blank">
							<span>{orderId}</span> <div className={" simple-icon-arrow-left-circle icongotoorder"} />
							<br />
							<span className={"text-muted"}>
								<NumberFormat style={{ textAlign: "center" }} value={totalPrice} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
							</span>
						</a>
					</td>
					<td style={{ verticalAlign: "middle", maxWidth: "275px" }}>
						<a href={"/app/crm/coupon/view/" + couponId} target="_blank">
							<div className="coupon" style={{ color: "#556270", transform: "scale(0.8)" }}>
								<span>{coupon.code}</span>
							</div>
						</a>
					</td>
					<td className={"text-muted"}>
						<Button
							className="mb-2 btn-just-icon"
							outline
							color="primary"
							style={{ margin: "0", marginTop: "10px" }}
							onClick={() => {
								this.setState({ modal: true });
							}}
						>
							<i className={"simple-icon-info"}></i>
						</Button>
						<Modal isOpen={this.state.modal} toggle={this.toggle}>
							<ModalHeader toggle={this.toggle}>استفاده از کوپن #{couponUseId}</ModalHeader>
							<ModalBody>
								<table style={{ width: "100%" }}>
									<tbody>
										<tr style={{ verticalAlign: "top" }}>
											<th>توضیحات:</th>
											<td>
												<ul style={{ direction: "ltr", textAlign: "left" }}>
													{description.split("|").map((part, index) => (
														<li key={index}>{part.trim()}</li>
													))}
												</ul>
											</td>
										</tr>
										<tr>
											<th>جمع کل:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={totalPrice} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>تخفیف کل:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={totalDiscount} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>قابل پرداخت:</th>
											<td>
												<NumberFormat style={{ textAlign: "center" }} value={payable} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
											</td>
										</tr>
										<tr>
											<th>اعمال کننده کوپن:</th>
											<td>
												<i className={"iconsminds-consulting"}></i> {operatorName}
											</td>
										</tr>
										<tr>
											<th>وضعیت:</th>
											<td>
												<i
													style={{ color: isDeleted == "1" ? "red" : "green" }}
													className={classNames({
														"simple-icon-close": isDeleted == "1" ? true : false,
														"simple-icon-check": isDeleted == "0" ? true : false,
													})}
												></i>{" "}
												<span style={{ color: isDeleted == "1" ? "red" : "green" }}>
													{classNames({
														"باطل شده": isDeleted == "1",
														"اعمل شده": isDeleted == "0",
													})}
												</span>
											</td>
										</tr>
									</tbody>
								</table>
							</ModalBody>
						</Modal>
					</td>
				</tr>
			</tbody>
		);
	}
}

class CouponTargetedTableRow extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
		};
		this.toggle = this.toggle.bind(this);
	}
	toggle() {
		if (this.state.clicked) {
			return;
		}
		this.setState({
			modal: !this.state.modal,
		});
	}

	render() {
		const {
			data: { couponID, createdAt, code, isUseable, subject, amount, type, expiresAt, minSpend, description },
		} = this.props;
		const typeMap = [];
		typeMap["FIXED"] = " تومان";
		typeMap["PERCENT"] = "%";
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>
				<tr className={"order-item"}>
					<td className={"text-muted"} style={{ verticalAlign: "middle", textAlign: "right" }}>
						<span style={{ color: "rgba(0,255,0,0.5)" }}>● </span>
						{moment(createdAt).locale("fa").format("YYYY/MM/DD - HH:mm")}
						<br />
						<span style={{ color: "rgba(255,0,0,0.5)" }}>● </span>
						{moment(expiresAt).locale("fa").format("YYYY/MM/DD - HH:mm")}
					</td>
					<td className={"text-muted"} style={{ verticalAlign: "middle" }}>
						{subject}
						<br />
						<NumberFormat style={{ textAlign: "center" }} value={amount} className="text-muted" displayType={"text"} suffix={typeMap[type]} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>
					<td style={{ verticalAlign: "middle", maxWidth: "275px" }}>
						<a href={"/app/crm/coupon/view/" + couponID} target="_blank">
							<div className="coupon" style={{ color: isUseable ? "#556270" : "#ff0000", transform: "scale(0.8)" }}>
								<span>{code}</span>
							</div>
						</a>
					</td>
				</tr>
			</tbody>
		);
	}
}
export default injectIntl(ViewCustomer);
